import ProviderList from './ProviderList';
import ProviderInfo from './ProviderInfo';

export default {
  ProviderList,
  ProviderInfo,
};
